// interfaces
import React, { lazy, Suspense } from 'react';
import { useQuery } from 'react-query';
import { Route, Switch } from 'react-router-dom';
import { Link } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { Auth } from '@/interfaces/auth';
// utils
import { setValue } from '@/utils/localStorage';
import { getPrivateUserInfo, userAuthorization } from '@/utils/queries';

// components
import { Progress } from './Progress';

const Profiles = lazy(() => import('./Profiles'));
const Profile = lazy(() => import('./Profile'));
const Branches = lazy(() => import('./Branches'));
const Branch = lazy(() => import('./Branch/Branch'));
const CreateFreeBranch = lazy(() => import('./Branch/CreateFreeBranch'));
const Telephones = lazy(() => import('./Telephones/Telephones'));
const Spreads = lazy(() => import('./Spreads/Spreads'));
const Photos = lazy(() => import('./Photos'));
const Applications = lazy(() => import('./Applications/Applications'));
const Application = lazy(() => import('./Applications/Application'));
const FreeBranchCorrections = lazy(
  () => import('./FreeBranchCorrections/FreeBranchCorrections')
);
const DevelopersDashboard = lazy(() => import('./DevelopersDashboard'));
const Reviews = lazy(() => import('./Reviews/Reviews'));
const Addresses = lazy(() => import('./Addresses'));
const Offices = lazy(() => import('./Offices/Offices'));
const Wallets = lazy(() => import('./Wallets/Wallets'));

const setToLocalStorage = (data: Auth) => {
  setValue('access_token', data.access_token);
  setValue('refresh_token', data.refresh_token);
};

export const App = () => {
  useQuery<Auth>(['auth'], userAuthorization, {
    onSuccess: setToLocalStorage,
  });

  const { data, isLoading, isError } = useQuery(
    ['PrivateUserInfo'],
    getPrivateUserInfo
  );

  if (isLoading) {
    return <Progress />;
  }

  if (isError) {
    return (
      <Alert severity="error">
        Помилка авторизації! Необхідно виконати вхід на{' '}
        <Link href={process.env.REACT_APP_SITE_URL} target="_blank">
          minfin.com.ua
        </Link>
      </Alert>
    );
  }

  //? Закомментировать проверку, если у вас нет аккаунта администратора
  //! Раскомментировать для продакшена

  if (data && data.profile_type !== 'admin') {
    return (
      <Alert severity="error">
        Помилка доступу! Користувач повинен мати права адміністратора
      </Alert>
    );
  }

  return (
    <>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route path="/" exact component={Reviews} />
          <Route path="/reviews" exact component={Reviews} />
          <Route path="/corrections" exact component={FreeBranchCorrections} />
          <Route path="/applications" exact component={Applications} />
          <Route path="/applications/:id" exact component={Application} />
          <Route path="/profiles" exact component={Profiles} />
          <Route path="/profiles/:id" exact component={Profile} />
          <Route path="/branches/" exact component={Branches} />
          <Route path="/branches/:id" exact component={Branch} />
          <Route path="/addresses" exact component={Addresses} />
          <Route path="/telephones" exact component={Telephones} />
          <Route path="/spreads" exact component={Spreads} />
          <Route path="/photos" exact component={Photos} />
          <Route path="/createFreeBranch" exact component={CreateFreeBranch} />
          <Route path="/developers" exact component={DevelopersDashboard} />
          <Route path="/offices" exact component={Offices} />
          <Route path="/wallets" exact component={Wallets} />
        </Switch>
      </Suspense>
    </>
  );
};
